import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ButtonFL } from '../ui/ButtonFL';

export const ErrorModal = ({ open, handleClose, error, labelButton }) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="error-dialog-title"
            aria-describedby="error-dialog-description"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle
                id="error-dialog-title"
                sx={{ color: 'var(--primary-dark-color)', position: 'relative', letterSpacing: 1 }}
            >
                Ops! Algo deu errado
                {error?.code && (
                    <span
                        style={{
                            position: 'absolute',
                            top: 8,
                            right: 16,
                            fontSize: '0.8rem',
                            color: 'rgba(0, 0, 0, 0.5)',
                        }}
                    >
                        {error?.code}
                    </span>
                )}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="error-dialog-description">
                    {
                        'Nossos sistemas estão passando por instabilidades. Por Favor, tente novamente em alguns instantes. '
                    }
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <ButtonFL textKey={labelButton || 'Ok, Entendi'} onClick={handleClose} />
            </DialogActions>
        </Dialog>
    );
};
